"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var DynReact;
    (function (DynReact) {
        var Navigation = /** @class */ (function (_super) {
            __extends(Navigation, _super);
            function Navigation() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.Shortcuts = $dyn.extendPrototype($dyn.ui.Control.prototype.Shortcuts, {
                    Activate: {
                        Category: $dyn.ui.ShortcutCategory.Navigate,
                        Description: $dyn.label("NavigationPane_NavigateItem"),
                        Handler: function () {
                            _this.navigate();
                        },
                        Keys: { keyCode: [$dyn.ui.KeyCodes.enter, $dyn.ui.KeyCodes.spacebar] },
                    },
                    ToggleFavorite: {
                        Description: function () {
                            var description = "";
                            if (_this.props.Favorite) {
                                description = $dyn.label("NavigationPane_RemoveFromFavorites");
                            }
                            else {
                                description = $dyn.label("NavigationPane_AddToFavorites");
                            }
                            return description;
                        },
                        Handler: function () {
                            DynReact.ModuleStore.setFavorite(_this.props.Id, !_this.props.Favorite);
                        },
                        Keys: { shift: true, keyCode: $dyn.ui.KeyCodes.letterF },
                    },
                });
                _this.handleClick = function () {
                    _this.navigate();
                };
                _this.clickFavorite = function (event) {
                    event.stopPropagation();
                    $dyn.log.stopPropagation && $dyn.log.stopPropagation("NavigationPane: stopPropagation when clicking the favorites icon.");
                    DynReact.ModuleStore.setFavorite(_this.props.Id, !_this.props.Favorite);
                };
                _this.keyHandler = function (event) {
                    $dyn.util.handleShortcuts(_this, event.nativeEvent);
                };
                return _this;
            }
            Navigation.prototype.navigate = function (options) {
                $dyn.applyFunction(this.props.BeforeNavigate);
                if (options && options.navigationOverride) {
                    $dyn.applyFunction(options.navigationOverride);
                }
                else {
                    var navItem = {
                        MenuItemName: this.props.MenuItemName,
                        MenuItemType: this.props.MenuItemType,
                        name: this.props.FormName,
                        navigationFeatureName: this.props.FeatureName,
                        navigationItemId: this.props.Id,
                        NavigationPath: JSON.parse(this.props.Id.split("#")[2]),
                    };
                    DynReact.ModuleStore.startNavigation(navItem);
                }
            };
            Navigation.prototype.favoriteText = function () {
                if (this.props.Favorite) {
                    return $dyn.label("NavigationPane_RemoveFromFavorites");
                }
                else {
                    return $dyn.label("NavigationPane_AddToFavorites");
                }
            };
            Navigation.prototype.getCrumbElement = function (removeModule) {
                var e_1, _a;
                var crumbLabels = this.getCrumbLabels();
                var crumbsElements = [];
                var crumbClasses = "modulesFlyout-crumb";
                if (removeModule) {
                    crumbLabels.shift();
                }
                try {
                    for (var crumbLabels_1 = __values(crumbLabels), crumbLabels_1_1 = crumbLabels_1.next(); !crumbLabels_1_1.done; crumbLabels_1_1 = crumbLabels_1.next()) {
                        var crumbLabel = crumbLabels_1_1.value;
                        crumbsElements.push(React.createElement("span", { className: crumbClasses }, crumbLabel));
                        crumbClasses = crumbClasses + " modulesFlyout-crumbDivider";
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (crumbLabels_1_1 && !crumbLabels_1_1.done && (_a = crumbLabels_1.return)) _a.call(crumbLabels_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return (React.createElement("div", null, crumbsElements));
            };
            Navigation.prototype.getCrumbText = function () {
                // Tool tips require a string
                var crumbLabels = this.getCrumbLabels();
                return $dyn.shell.joinArrayWithChevron(crumbLabels);
            };
            Navigation.prototype.onmouseenter = function (event) {
                $dyn.superTooltip.tryOpenSuperTooltip(event.target);
            };
            Navigation.prototype.getCrumbLabels = function () {
                var crumbLabels = DynReact.ModuleStore.getNavigationPath(this.props.Id);
                if (crumbLabels.length > 1) {
                    crumbLabels.pop(); // Only include the parents, not myself
                }
                else {
                    crumbLabels[0] = $dyn.label("NavigationPane_Workspaces");
                }
                return crumbLabels;
            };
            return Navigation;
        }(React.PureComponent));
        DynReact.Navigation = Navigation;
    })(DynReact = $dyn.DynReact || ($dyn.DynReact = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Navigation.js.map
